"use client";

import { useSelector } from "react-redux";

import type { AccessContext } from "@sdk/access";
import { selectAccessContext } from "@/store/modules/users/users.selectors";
import { resolveAccessContext } from "@sdk/access/resolve-access-context";
import {
  selectCurrentUser,
  selectCurrentUserId,
} from "@/store/modules/users/users.selectors";

export function useAccess(): AccessContext | null {
  return useSelector(selectAccessContext);
}

export function useAccessOrEmpty(): AccessContext {
  const ctx = useAccess();
  const userId = useSelector(selectCurrentUserId);
  const user = useSelector(selectCurrentUser);

  if (ctx) return ctx;

  return resolveAccessContext({
    userId: userId ?? "",
    organizationId: user?.organizationId ?? "",
  });
}

export { selectAccessContext } from "@/store/modules/users/users.selectors";
